// extracted by mini-css-extract-plugin
export default {"slider":"Slider-module__slider--sT_tN"};